export default __webpack_public_path__ + "static/media/emptyPokemon.0d694788.png";